import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import Checkbox from 'ext-ui/components/Checkbox/Checkbox'
import React from 'react'
import { useSelector } from 'react-redux'
import OnOffSwitch from 'src/components/OnOffSwitch/OnOffSwitch'
import { useTranslate } from 'src/localization/Trns'
import { TransactionReceiptStatus } from 'src/models/transaction.models'
import { selectBrandColorCta } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

interface TransactionReceiptStatusFilterProps {
  receiptStatusSet: Set<string>
  handleReceiptStatusSelection: (status: string) => Set<string>
  receiptRequired: boolean | undefined
  setReceiptRequired: (required: boolean) => void
}

const TransactionReceiptStatusFilter: React.FC<
  TransactionReceiptStatusFilterProps
> = ({
  receiptStatusSet,
  handleReceiptStatusSelection,
  receiptRequired,
  setReceiptRequired,
}) => {
  const brandColorCta = useSelector(selectBrandColorCta)
  const translate = useTranslate()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        {translate('Receipt Status')}
      </div>
      <div className="flex-row align-center gap-2">
        <Checkbox
          id="receipt-status-attached"
          onChange={(): void => {
            handleReceiptStatusSelection(TransactionReceiptStatus.Attached)
          }}
          checked={receiptStatusSet.has(TransactionReceiptStatus.Attached)}
          aria-label={translate('Attached')}
        />
        <label
          htmlFor="receipt-status-attached"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          {translate('Attached')}
        </label>
      </div>
      <div className="flex-row align-center gap-2">
        <Checkbox
          id="receipt-status-missing"
          onChange={(): void => {
            handleReceiptStatusSelection(TransactionReceiptStatus.Missing)
          }}
          checked={receiptStatusSet.has(TransactionReceiptStatus.Missing)}
          aria-label={translate('Missing')}
        />
        <label
          htmlFor="receipt-status-missing"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          {translate('Missing')}
        </label>
      </div>
      <div
        css={css`
          margin-top: 20px;
          display: flex;
          align-items: flex-start;
          gap: 8px;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
          `}
        >
          {translate('Only show transactions that require receipts')}
        </span>
        <OnOffSwitch
          onBgColor={brandColorCta}
          smallMode
          defaultOnOffState={receiptRequired}
          onChange={(val: boolean): void => {
            setReceiptRequired(val)
          }}
        />
      </div>
    </div>
  )
}

export default TransactionReceiptStatusFilter
